export default __webpack_public_path__ + "static/FIEMA_R&D-7c3fdfd3e8e9e2a3b598c2f56308ef6a.png";